var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","router":"","to":"/view/group"},slot:"activator"},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("group_work")]),_vm._v("\n    "+_vm._s(_vm.nbGroups)+"\n  ")],1),_vm._v(" "),_c('span',[_vm._v("Groups")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5152b9a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/group/Chip.vue
// module id = null
// module chunks = 